import React, { useEffect, useState } from 'react';
import { ArrowUpRight } from 'lucide-react';

const ProjectCard = ({ project, onOpen }) => {
  const imgs = project.images && project.images.length > 0 ? project.images : [project.image];
  const isCarousel = imgs.length > 1;
  const [idx, setIdx] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (!isCarousel || paused) return undefined;
    const t = setInterval(() => {
      setIdx((v) => (v + 1) % imgs.length);
    }, 3800);
    return () => clearInterval(t);
  }, [isCarousel, imgs.length, paused]);

  return (
    <button
      type="button"
      onClick={() => onOpen(project, idx)}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      className="group relative block w-full rounded-sm overflow-hidden aspect-[4/5] card-lift text-left"
      aria-label={`Open ${project.title}`}
    >
      {imgs.map((src, i) => (
        <img
          key={src}
          src={src}
          alt={`${project.title} ${i + 1}`}
          loading="lazy"
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-[900ms] ease-[cubic-bezier(.2,.7,.2,1)] ${
            i === idx ? 'opacity-100' : 'opacity-0'
          } ${i === idx ? 'group-hover:scale-[1.05]' : ''}`}
          style={
            i === idx
              ? { transition: 'opacity 900ms ease, transform 1.2s cubic-bezier(.2,.7,.2,1)' }
              : undefined
          }
        />
      ))}
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent pointer-events-none" />

      {isCarousel && (
        <div className="absolute top-4 left-1/2 -translate-x-1/2 flex items-center gap-1.5 z-10">
          {imgs.map((src, i) => (
            <span
              key={`dot-${src}`}
              onClick={(e) => {
                e.stopPropagation();
                setIdx(i);
              }}
              role="button"
              aria-label={`Show image ${i + 1}`}
              className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${
                i === idx ? 'w-6 bg-white' : 'w-1.5 bg-white/50 hover:bg-white/80'
              }`}
            />
          ))}
        </div>
      )}

      <div className="absolute inset-0 p-6 flex flex-col justify-end">
        <div className="text-[10px] tracking-[0.3em] uppercase text-[#B8935A] mb-2">
          {project.category}
        </div>
        <div className="flex items-end justify-between gap-4">
          <h3 className="font-serif text-2xl md:text-[26px] leading-tight text-white">
            {project.title}
          </h3>
          <span className="w-10 h-10 rounded-full border border-white/50 flex items-center justify-center flex-shrink-0 text-white group-hover:bg-[#7B1E24] group-hover:border-[#7B1E24] transition-all duration-300">
            <ArrowUpRight size={16} />
          </span>
        </div>
      </div>
    </button>
  );
};

export default ProjectCard;
